import {
  restaurantsPath,
} from './restaurantRequests';

export const restaurantCategoriesPath = `${restaurantsPath}/categories`;

export const meals = (categoryId: number) => `${restaurantCategoriesPath}/${categoryId}/meals`;
export const mealById = (mealId: number) => `${restaurantCategoriesPath}/meals/${mealId}`;
export const updateMealStatus = (id: number) => `${restaurantCategoriesPath}/meals/${id}/activation`;
